var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { cssClassMap } from '../../../constants/SportCssMap';
import { leagueSortFunc } from '../../../rendering-commons/Sorting';
import League from './League';
var Sports = /** @class */ (function (_super) {
    __extends(Sports, _super);
    function Sports() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showInner: false
        };
        _this.toggleInner = function () {
            var showInner = _this.state.showInner;
            _this.setState({
                showInner: !showInner
            });
        };
        return _this;
    }
    Sports.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.leagues !== this.props.leagues || nextState.showInner !== this.state.showInner;
    };
    Sports.prototype.render = function () {
        var _this = this;
        var _a = this.props, sport = _a.sport, leagues = _a.leagues;
        var showInner = this.state.showInner;
        if (leagues === undefined) {
            return false;
        }
        var sportCssName = cssClassMap[sport.get('id')];
        var sportLeaguesIds = sport.get('leagues');
        var sportLeagues = sportLeaguesIds.map(function (l) { return leagues.get(l); });
        var renderLeagues = [];
        sportLeagues.sort(leagueSortFunc).map(function (league) {
            renderLeagues.push(_jsx(League, { league: league, section: _this.props.section, sportCssName: sportCssName }, league));
        });
        var itemCls = showInner ? ' selected' : '';
        return (_jsx("div", __assign({ className: 'results' }, { children: _jsxs("div", __assign({ className: "container".concat(itemCls) }, { children: [_jsxs("div", __assign({ className: 'header toggle', onClick: this.toggleInner }, { children: [_jsx("img", { src: require("../../../assets/img/icons/".concat(sportCssName, ".svg")), alt: '' }), this.props.sport.get('name')] })), _jsx("div", __assign({ className: 'items' }, { children: renderLeagues }))] })) })));
    };
    return Sports;
}(React.Component));
Sports.propTypes = {
    sport: PropTypes.object.isRequired,
    leagues: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired
};
export default Sports;



// WEBPACK FOOTER //
// ./src/components/info/results/Sports.jsx